import * as React from 'react'
import * as Reakit from 'reakit/Tooltip'

import { isIos } from '../../../app/shared/isMobile'
import { getExtendedDialogState } from '../dialog'
import { TooltipArrow } from './tooltip-arrow'
import { TooltipBox, TooltipBoxProps } from './tooltip-box'

interface TooltipProps extends TooltipBoxProps {
  /**
   * The returned object from `useTooltipState`
   */
  state: Reakit.TooltipStateReturn
}

export function Tooltip({ state, children, color = 'none', ...props }: React.PropsWithChildren<TooltipProps>) {
  const { isFullyClosed } = getExtendedDialogState(state)

  // On iOS depending on composition TooltipTrigger doesn't work properly if Tooltip isn't always rendered
  // and causes bug on interactive elements with tooltip like selects, buttons, etc. when on first click
  // only tooltip appears but select, button or etc. doesn't receive event so it won't open, also on first click
  // in iOS safari onClick event isn't fired no TooltipTrigger, just onPointerDown, and thus further breaking logic
  // because our custom callback which are placed in onClick aren't invoked, after debugging we think that this
  // is bug caused by combination of reakit behaviour when <Tooltip> isn't always rendered and way of events
  // firing by iOS Safari and thus not worth debugging internal reakit logic as we are looking to
  // replace it altogether
  if (isFullyClosed && !isIos()) return null
  return (
    <Reakit.Tooltip {...state}>
      {({ onTransitionEnd, onAnimationEnd, ...tooltipProps }) => (
        <div {...tooltipProps} className="finviz-popover z-dialog outline-none">
          <TooltipBox
            {...props}
            color={color}
            onTransitionEnd={onTransitionEnd}
            onAnimationEnd={onAnimationEnd}
            data-placement={state.placement}
          >
            <Reakit.TooltipArrow {...state} size={11}>
              <TooltipArrow placement={state.placement} color={color} />
            </Reakit.TooltipArrow>
            {children}
          </TooltipBox>
        </div>
      )}
    </Reakit.Tooltip>
  )
}
